import {
  SlideAction,
  SlideLayout,
  type SlideLayoutLocationState,
  ViewMode,
} from '@gripp/shared-ui';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ActivityEditColumn } from './activityEditColumn';
import { ActivityReassignColumn } from './activityReassignColumn';

const ACTIVITY_REASSIGN_SOURCE =
  'gripp-workspace/apps/gripp-web/src/activity/components/activity-reassign.tsx';
const ACTIVITY_EDIT_COLUMN_SOURCE =
  'gripp-workspace/apps/gripp-web/src/activity/components/activityEditColumn.tsx';

export const ActivityReassign = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { issueId = '' } = useParams();
  const locationState = location.state as SlideLayoutLocationState | null;
  const initialTransition =
    locationState?.slideLayoutInitialTransition === SlideAction.NEXT ||
    locationState?.slideLayoutInitialTransition === SlideAction.PREV
      ? locationState.slideLayoutInitialTransition
      : undefined;

  const getStateWithTransition = (transition: SlideAction) => {
    const currentState =
      location.state && typeof location.state === 'object'
        ? (location.state as Record<string, unknown>)
        : {};

    return {
      ...currentState,
      slideLayoutInitialTransition: transition,
    };
  };

  const leftColumn = {
    title: 'issue.menu.edit',
    mainComponent: <ActivityEditColumn />,
    onBackButtonPress: () => {
      navigate('../..', {
        relative: 'path',
        state: {
          ...getStateWithTransition(SlideAction.PREV),
          skipAutoSelect: true,
        },
      });
    },
    backButtonTransition: SlideAction.PREV,
    backButtonTransitionBehavior: 'concurrent' as const,
    backButtonTransitionExitColumn: 'both' as const,
    showBackButton: true,
    disableScroll: true,
    debug: {
      id: 'activity-edit:edit',
      titleKey: 'issue.menu.edit',
      component: 'ActivityEditColumn',
      componentSource: ACTIVITY_EDIT_COLUMN_SOURCE,
      columnSource: ACTIVITY_REASSIGN_SOURCE,
      ownerComponent: 'ActivityReassign',
      ownerSource: ACTIVITY_REASSIGN_SOURCE,
      routePanelKey: 'activity-edit-reassign',
      routePattern: '/activities/:issueId/edit/reassign',
      routeSource: 'gripp-workspace/apps/gripp-web/src/activity/routes.tsx',
      source: {
        owner: {
          file: ACTIVITY_REASSIGN_SOURCE,
          symbol: 'ActivityReassign',
        },
        column: {
          file: ACTIVITY_REASSIGN_SOURCE,
          symbol: 'leftColumn',
        },
        component: {
          file: ACTIVITY_EDIT_COLUMN_SOURCE,
          symbol: 'ActivityEditColumn',
        },
        route: {
          file: 'gripp-workspace/apps/gripp-web/src/activity/routes.tsx',
          symbol: 'activityRoutes',
        },
      },
      entity: { type: 'activity-edit', id: issueId },
    },
  };

  const rightColumn = {
    title: 'issue.menu.reassign',
    mainComponent: <ActivityReassignColumn />,
    onBackButtonPress: () => {
      navigate('..', {
        relative: 'path',
        state: getStateWithTransition(SlideAction.PREV),
      });
    },
    backButtonTransition: SlideAction.PREV,
    backButtonTransitionBehavior: 'concurrent' as const,
    showBackButton: true,
    disableScroll: true,
  };

  return (
    <SlideLayout
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      viewMode={ViewMode.DUAL}
      initialTransition={initialTransition}
    />
  );
};
